export default __webpack_public_path__ + "static/media/CNo.82-0.dcf7bec8.jpg";